import { Outlet } from "react-router-dom";
import Footer from "./footer";
import TopNav from "./top-nav";

function HomeLayout() {
  return (
    <div className="w-full h-screen bg-light overflow-y-auto style-scroll">
      <div className="relative top-0 left-0 top-desti" />
      <TopNav />
      <div className="min-h-screen flex flex-col pt-14 md:pt-20 ">
        <div className="flex-grow">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default HomeLayout;
